import React, { useState } from 'react';
import bg1 from './../assets/images/background/newsletter.webp';
import { API_BASE_URL } from '../config/api';
import Swal from 'sweetalert2';

function NewsLetter({ subscribeChange }) {
    const [email, setEmail] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [message, setMessage] = useState({ type: '', text: '' });

    const showSuccessPopup = () => {
        Swal.fire({
            title: '✨ Thank you for joining Art Tokri!',
            html: `You'll now receive inspiring artist stories, handmade art drops, and creative updates directly in your inbox.<br/><br/>
                   <span style="font-size: 14px; color: #f59e0b;">We're excited to have you with us! 🎨</span>`,
            icon: 'success',
            iconColor: '#f59e0b',
            background: '#fffaf0',
            timer: 4000,
            timerProgressBar: true,
            showConfirmButton: false,
            showCancelButton: false,
            allowOutsideClick: false,
            didOpen: (popup) => {
                popup.style.borderRadius = '20px';
                popup.style.border = '2px solid #fde68a';
            }
        });
    };

    const showErrorPopup = (errorMessage) => {
        Swal.fire({
            title: '❌ Subscription Failed',
            text: errorMessage || 'Please check your email and try again.',
            icon: 'error',
            iconColor: '#ef4444',
            confirmButtonText: 'Try Again',
            confirmButtonColor: '#f59e0b',
            background: '#fffaf0',
            timer: 3000,
            timerProgressBar: true,
            customClass: {
                popup: 'subscribe-popup',
                confirmButton: 'subscribe-popup-button'
            }
        });
    };

    const showAlreadySubscribedPopup = () => {
        Swal.fire({
            title: '🎨 Already Subscribed!',
            text: 'You are already a part of our creative community. Thank you for your support!',
            icon: 'info',
            iconColor: '#f59e0b',
            confirmButtonText: 'Great!',
            confirmButtonColor: '#f59e0b',
            background: '#fffaf0',
            timer: 3000,
            timerProgressBar: true,
            customClass: {
                popup: 'subscribe-popup',
                confirmButton: 'subscribe-popup-button'
            }
        });
    };

    const handleSubscribe = async (e) => {
        e.preventDefault();
        if (!email) return;

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            showErrorPopup('Please enter a valid email address');
            return;
        }

        setIsSubmitting(true);
        setMessage({ type: '', text: '' });

        try {
            const response = await fetch(`${API_BASE_URL}/server/website/support/subscribe_user`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email }),
            });

            const data = await response.json();

            if (data.success) {
                setMessage({ type: 'success', text: 'Thank you for subscribing!' });
                setEmail('');
                showSuccessPopup();
            } else {
                if (data.message && data.message.includes('already subscribed')) {
                    showAlreadySubscribedPopup();
                } else {
                    showErrorPopup(data.message || 'Subscription failed. Please try again.');
                }
                setMessage({ type: 'error', text: data.message || 'Subscription failed. Please try again.' });
            }
        } catch (error) {
            console.error('Subscription error:', error);
            showErrorPopup('Something went wrong. Please try again later.');
            setMessage({ type: 'error', text: 'Something went wrong. Please try again later.' });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>
            <section className={`py-5 newsletter-wrapper ${subscribeChange || ''}`} style={{ backgroundImage: `url(${bg1})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                <div className="container">
                    <div className="subscride-inner">
                        <div className="row style-1 justify-content-xl-between justify-content-lg-center align-items-center text-xl-start text-center">
                            <div className="col-xl-7 col-lg-12">
                                <div className="section-head mb-0">
                                    <h2 className="title text-white my-lg-3 mt-0" style={{ fontSize: 'clamp(1.5rem, 4vw, 2.5rem)', fontWeight: '600' }}>
                                        Get stories behind every handmade creation
                                    </h2>
                                </div>
                            </div>
                            <div className="col-xl-5 col-lg-6">
                                <form className="newsletter-form-unique" onSubmit={handleSubscribe}>
                                    <div className="newsletter-form-group-unique">
                                        <div className="newsletter-input-wrapper-unique">
                                            <input
                                                name="dzEmail"
                                                required
                                                type="email"
                                                className="newsletter-input-unique"
                                                placeholder="Your Email Address"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                disabled={isSubmitting}
                                            />
                                            <button
                                                name="submit"
                                                value="Submit"
                                                type="submit"
                                                className="newsletter-submit-btn-unique"
                                                disabled={isSubmitting}
                                            >
                                                <span>{isSubmitting ? 'SUBSCRIBING...' : 'SUBSCRIBE'}</span>
                                                <i className="fa-solid fa-paper-plane"></i>
                                            </button>
                                        </div>
                                    </div>
                                    {message.text && (
                                        <div className={`subscribe-message ${message.type}`} style={{
                                            color: message.type === 'success' ? '#4ade80' : '#f87171',
                                            marginTop: '10px',
                                            fontSize: '14px',
                                            textAlign: 'left'
                                        }}>
                                            {message.text}
                                        </div>
                                    )}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <style jsx="true">{`
                /* Unique Newsletter Form Styles */
                .newsletter-form-unique {
                    width: 100%;
                }

                .newsletter-form-group-unique {
                    width: 100%;
                }

                .newsletter-input-wrapper-unique {
                    position: relative;
                    display: flex;
                    align-items: center;
                    width: 100%;
                    background: rgba(255, 255, 255, 0.15);
                    border-radius: 50px;
                    border: 1px solid rgba(255, 255, 255, 0.3);
                    transition: all 0.3s ease;
                }

                // .newsletter-input-wrapper-unique:hover {
                //     object-fit:cover;
                //     background: rgba(255, 255, 255, 0.2);
                //     border-color: rgba(255, 255, 255, 0.5);
                // }

                .newsletter-input-unique {
                    flex: 1;
                    background: transparent;
                    border: none;
                    padding: 14px 24px;
                    font-size: 16px;
                    color: white;
                    outline: none;
                    border-radius: 50px;
                    font-weight: 400;
                }

                .newsletter-input-unique::placeholder {
                    color: rgba(255, 255, 255, 0.7);
                    font-size: 15px;
                }

                .newsletter-input-unique:focus {
                    outline: none;
                }

                .newsletter-input-unique:disabled {
                    opacity: 0.7;
                    cursor: not-allowed;
                }

                .newsletter-submit-btn-unique {
                    background: #f59e0b;
                    border: none;
                    padding: 12px 28px;
                    border-radius: 50px;
                    color: white;
                    font-weight: 600;
                    font-size: 14px;
                    letter-spacing: 1px;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    white-space: nowrap;
                    display: inline-flex;
                    align-items: center;
                    gap: 8px;
                    margin: 4px;
                }

                .newsletter-submit-btn-unique:hover:not(:disabled) {
                    background: #d97706;
                    transform: translateY(-2px);
                    box-shadow: 0 4px 15px rgba(245, 158, 11, 0.4);
                }

                .newsletter-submit-btn-unique:active:not(:disabled) {
                    transform: translateY(0);
                }

                .newsletter-submit-btn-unique:disabled {
                    opacity: 0.7;
                    cursor: not-allowed;
                }

                .newsletter-submit-btn-unique i {
                    font-size: 14px;
                    transition: transform 0.3s ease;
                }

                .newsletter-submit-btn-unique:hover:not(:disabled) i {
                    transform: translateX(4px);
                }

                /* Responsive Styles */
                @media (max-width: 1200px) {
                    .newsletter-input-unique {
                        padding: 12px 20px;
                        font-size: 15px;
                    }
                    
                    .newsletter-submit-btn-unique {
                        padding: 10px 24px;
                        font-size: 13px;
                    }
                }

                @media (max-width: 992px) {
                    .newsletter-input-wrapper-unique {
                        max-width: 500px;
                        margin: 0 auto;
                    }
                }

                @media (max-width: 768px) {
                    .newsletter-input-wrapper-unique {
                        flex-direction: column;
                        background: transparent;
                        border: none;
                        gap: 12px;
                    }

                    .newsletter-input-unique {
                        width: 100%;
                        background: rgba(255, 255, 255, 0.15);
                        border: 1px solid rgba(255, 255, 255, 0.3);
                        border-radius: 50px;
                        padding: 12px 20px;
                        text-align: center;
                    }

                    .newsletter-submit-btn-unique {
                        width: 100%;
                        justify-content: center;
                        padding: 12px 24px;
                        margin: 0;
                    }

                    .newsletter-input-unique::placeholder {
                        text-align: center;
                        font-size: 14px;
                    }
                }

                @media (max-width: 576px) {
                    .newsletter-input-unique {
                        padding: 10px 16px;
                        font-size: 14px;
                    }

                    .newsletter-submit-btn-unique {
                        padding: 10px 20px;
                        font-size: 12px;
                    }

                    .newsletter-submit-btn-unique span {
                        font-size: 12px;
                    }
                }

                /* Small devices */
                @media (max-width: 480px) {
                    .newsletter-input-unique {
                        padding: 10px 16px;
                        font-size: 13px;
                    }

                    .newsletter-submit-btn-unique {
                        padding: 10px 16px;
                    }

                    .subscribe-message {
                        font-size: 12px;
                        text-align: center !important;
                    }
                }

                /* Popup Styles */
                .subscribe-popup {
                    font-family: inherit;
                    animation: fadeInUp 0.3s ease;
                }
                
                .subscribe-popup-title {
                    font-size: 24px;
                    font-weight: 700;
                    color: #78350f;
                }
                
                .subscribe-popup-content {
                    font-size: 16px;
                    color: #92400e;
                    line-height: 1.6;
                }
                
                .subscribe-popup-button {
                    padding: 10px 24px;
                    font-size: 14px;
                    font-weight: 600;
                    border-radius: 8px;
                    transition: all 0.3s ease;
                }
                
                .subscribe-popup-button:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 4px 12px rgba(245, 158, 11, 0.3);
                }
                
                @keyframes fadeInUp {
                    from {
                        opacity: 0;
                        transform: translateY(20px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
            `}</style>
        </>
    );
}

export default NewsLetter;